/* np-bloodwork — ported from the Replo homepage bloodwork tabs
   (data-rid d221caf9-7dc7-4d73-ab46-17df5c9d6e62).

   Replo uses a Radix vertical Tabs component. This drives the same DOM
   contract: triggers carry role="tab" + aria-selected + data-state, panels
   carry role="tabpanel" + data-state, and only the active panel is shown. */
(function () {
  'use strict';

  function initRoot(root) {
    if (!root || root.dataset.npBwInit === 'true') return;
    root.dataset.npBwInit = 'true';

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-np-bw-trigger]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-np-bw-panel]'));
    if (!panels.length) return;

    /* Replay the bar reveal. Removing the class, forcing a reflow and
       re-adding it restarts the CSS animation — without the reflow the
       browser coalesces the two class changes and nothing replays. */
    function replay(panel) {
      panel.classList.remove('is-animating');
      void panel.offsetWidth;
      panel.classList.add('is-animating');
    }

    /* No tabs (sections/np-pdp-bloodwork.liquid: one product, one panel) —
       just reveal the bars the first time the section scrolls into view. */
    if (!triggers.length) {
      if ('IntersectionObserver' in window) {
        var once = new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) return;
            once.disconnect();
            panels.forEach(replay);
          },
          { threshold: 0.2 }
        );
        once.observe(root);
      } else {
        panels.forEach(replay);
      }
      return;
    }

    function select(i, animate) {
      triggers.forEach(function (t, n) {
        var on = n === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('data-state', on ? 'active' : 'inactive');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (p, n) {
        var on = n === i;
        p.setAttribute('data-state', on ? 'active' : 'inactive');
        p.hidden = !on;
        if (!on) p.classList.remove('is-animating');
      });
      if (animate !== false && panels[i]) replay(panels[i]);
    }

    triggers.forEach(function (t, i) {
      t.addEventListener('click', function () {
        select(i);
      });
      t.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (i + 1) % triggers.length;
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft')
          next = (i - 1 + triggers.length) % triggers.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = triggers.length - 1;
        else return;
        e.preventDefault();
        select(next);
        triggers[next].focus();
      });
    });

    var start = triggers.findIndex(function (t) {
      return t.getAttribute('aria-selected') === 'true';
    });
    if (start < 0) start = 0;

    /* Set up state without animating, then let the first panel reveal when
       it scrolls into view — Replo ships these paused and un-pauses them
       on entry, so firing at load would waste the animation off-screen. */
    select(start, false);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.disconnect();
            var active = panels.filter(function (p) {
              return !p.hidden;
            })[0];
            if (active) replay(active);
          });
        },
        { threshold: 0.2 }
      );
      io.observe(root);
    } else {
      replay(panels[start]);
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-np-bw]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
